import { GET_CONTENT } from '@plone/volto/constants/ActionTypes';
import { GET_SLOTS } from 'mpf-slots-frontend/constants';
// Imports diretos, e não pelo barril `@plone/volto/helpers`: o barril arrasta
// o `Html.jsx` (e o `serialize-javascript`, que exige o global `crypto`) para
// dentro de qualquer consumidor — inclusive um teste de reducer puro, que
// nem monta componente. Mesmo padrão do `View.jsx` customizado.
import { flattenToAppURL, getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { hasApiExpander } from '@plone/volto/helpers/Utils/Utils';

function getRequestKey(actionType) {
  return actionType.split('_')[0].toLowerCase();
}

export default function slots(state = {}, action = {}) {
  let { result } = action;
  let hasExpander;

  switch (action.type) {
    case `${GET_SLOTS}_PENDING`:
      return {
        ...state,
        [getRequestKey(action.type)]: {
          loading: true,
          loaded: false,
          error: undefined,
        },
      };
    case `${GET_CONTENT}_SUCCESS`:
      hasExpander = hasApiExpander('slots', getBaseUrl(flattenToAppURL(action.result['@id'])));
      if (hasExpander && !action.subrequest) {
        return {
          ...state,
          error: null,
          // `@components.slots`, e não `@components`: os consumidores leem
          // `slotData.items[nome]`, e `items` vive dentro da chave do
          // expander — o mesmo payload que o GET de `@slots` devolve.
          data: action.result['@components']?.slots || {},
          // O mesmo `get` que o fetch avulso alimenta: quem decide se já dá
          // pra renderizar (o `EditSlot`) lê `state.slots.get.loaded`, e com o
          // expander no lugar o dado pode chegar por aqui primeiro — inclusive
          // já no HTML do SSR. Um `loaded` solto na raiz não era lido por
          // ninguém.
          [getRequestKey(GET_SLOTS)]: {
            loading: false,
            loaded: true,
            error: undefined,
          },
        };
      }
      return state;
    // Sem a guarda de `hasApiExpander` que o reducer de navegação do core usa:
    // lá o fetch avulso é o *fallback* de quem não tem expander, aqui ele é
    // deliberado e mais rico — o `EditSlot` pede `@slots?full=true`, e é o
    // `full` que traz os fills herdados/ocultos que a tela de edição precisa
    // mostrar (`Slots.get_data` não para no `block_parent`). Descartar essa
    // resposta deixava `get.loaded` em falso para sempre e a tela de edição
    // renderizava vazia — nem editor, nem "Não autorizado".
    case `${GET_SLOTS}_SUCCESS`:
      return {
        ...state,
        data: {
          ...result,
        },
        [getRequestKey(action.type)]: {
          loading: false,
          loaded: true,
          error: undefined,
        },
      };
    case `${GET_SLOTS}_FAIL`:
      return {
        ...state,
        [getRequestKey(action.type)]: {
          loading: false,
          loaded: false,
          error: action.error,
        },
      };
    default:
      break;
  }
  return state;
}
